/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_Unscheduled_HideInputs */

const en_tl_unscheduled_hide = /** @type {(inputs: Tl_Unscheduled_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide unscheduled items`)
};

const de_tl_unscheduled_hide = /** @type {(inputs: Tl_Unscheduled_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorgänge ohne Termin ausblenden`)
};

/**
* | output |
* | --- |
* | "Hide unscheduled items" |
*
* @param {Tl_Unscheduled_HideInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_unscheduled_hide = /** @type {((inputs?: Tl_Unscheduled_HideInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Unscheduled_HideInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_unscheduled_hide(inputs)
	return en_tl_unscheduled_hide(inputs)
});